<div class="account-info me-5 d-flex justify-content-between align-items-center text-center" style="position: relative;z-index: 457;">
    <!-- in case no another organizations -->
    <ng-container *ngIf="orgList.length <= 1">
      <figure>
        <img src="./assets/images/icons-navbar/ic-profile.svg" class="profile-icon mt-3 me-2" alt="ic-profile"/>
      </figure>
      <span class="account-name me-2">{{ (userObj?.first_name + ' ' + userObj?.last_name)|titlecase }}</span>
    </ng-container>
    <!-- in case another organizations -->
    <ng-container *ngIf="orgList.length > 1">
      <figure>
        <img src="./assets/images/org.png" class="profile-icon mt-3 me-2" alt="ic-profile"/>
      </figure>
      <span class="account-name me-2">{{ userObj?.company_name}}</span>
    </ng-container>
    <figure (click)="showProfileMenu()" style="cursor: pointer;">
      <img
        src="./assets/images/icons-navbar/ic-chevron.svg"
        class="down-arrow mt-3"
        alt="ic-chevron"
      />
    </figure>
    <div class="account-info-tab" [class.orgInContainer]="orgList.length > 1">
      <!-- in case no another organizations -->
      <ng-container *ngIf="orgList.length <= 1">
        <ul>
            <li class="nav-item"><a class="nav-link" (click)="messageComponent.open()">Logout</a></li>
        </ul>
      </ng-container>
      <!-- in case another organizations -->
      <ng-container *ngIf="orgList.length > 1">
        <ul class="org-list">
            <li class="nav-item li-active"><a class="nav-link active">
              <div class="avatar-img"></div>
              <div class="info-account">
                <div class="company-name">{{userObj?.company_name}} <span>(Default)</span></div>
              </div>
            </a></li>
            <ng-container *ngFor="let org of orgList">
              <li *ngIf="org?.domain != userObj?.sub_domain" class="nav-item" (click)="openConfirmMsgSwitchOrg(org)"><a class="nav-link">
                <div class="avatar-img"></div>
                <div class="info-account">
                  <div class="company-name">{{org?.name}}</div>
                </div>
              </a></li>
            </ng-container>
            <li class="nav-item li-logout"><a class="nav-link logout" (click)="messageComponent.open()">Logout</a></li>
        </ul>
      </ng-container>
    </div>
</div>

<div class="overlay-navbar" (click)="closeProfileMenu()"></div>

<!-- confirmation message -->
<app-confirmation-msg
  class="conformation"
  #confirmMessageComponent
  [isLoading]="loadingSubmit"
  (accepted)="switchOrg()"
  (rejected)="confirmMessageComponent.close();selectedOrg=''"
  [headerMessage]="'Confirmation Message'"
  [bodyMessage]="'Are you sure you want to log in by ' + selectedOrg?.name + ' ?' "
>
</app-confirmation-msg>

<!-- confirmation message -->
<app-confirmation-msg 
#messageComponent
[isLoading] = 'loadingSubmit'
(accepted)="accepted()" 
(rejected)="rejected()"
[headerMessage]="'Confirmation Message'"
[bodyMessage] = "'Do you want to logout from the system?'">
</app-confirmation-msg>